module.exports = __webpack_public_path__ + "static/media/turkey.ea5f2f95.svg";